import React from "react";
import { Button } from "@/components/ui/button";
import { Check, ArrowRight, Star } from "lucide-react";
import { Link } from "react-router-dom";

const TocTocServices = () => {
  const services = [
    {
      title: "Ensaio Único",
      alt: "Quarto fotografado — Ensaio Único em Balneário Camboriú",
      price: "Sob consulta",
      description: "Para imóveis avulsos — ideal para lançamentos ou atualizações pontuais.",
      features: [
        "Edição profissional e correção de cores",
        "Entrega em até 48h",
        "Iluminação especializada",
        "Vários ângulos e composição estratégica",
      ],
      additionalInfo: "Indicado para quando você precisa de um ensaio pontual com resultado profissional.",
      image: "/lovable-uploads/2972e843-ebe4-4775-8d5d-333ae298c654.png",
    },
    {
      title: "Plano Mensal Toc Toc",
      alt: "Sala gourmet — Plano Mensal para imobiliárias em Itajaí",
      price: "Sob consulta",
      description: "Para corretores e imobiliárias que vendem com frequência.",
      features: [
        "Ensaios recorrentes com previsibilidade e agilidade",
        "Entrega padronizada em até 48h",
        "Imagens consistentes para seus anúncios",
        "Organização mensal para diversos imóveis",
        "Custo-benefício muito mais atrativo",
      ],
      additionalInfo:
        "A escolha número 1 de quem anuncia com frequência e quer reduzir custos por imóvel sem abrir mão da qualidade.",
      image: "/lovable-uploads/0bf40fa0-33c5-401b-8b40-115110e05f5a.png",
      popular: true,
    },
    {
      title: "Fotografia para Airbnb & Temporada",
      alt: "Área de lazer instagramável — Airbnb & Temporada em Itapema",
      price: "Sob consulta",
      description: "Para anfitriões, pousadas e imóveis de locação por temporada.",
      features: [
        "Destaque de experiências e ambientes instagramáveis",
        "Edição com foco em luz natural e estética acolhedora",
        "Consultoria visual para maximizar reservas",
        "Entrega em até 48h",
        "Material ideal para plataformas como Airbnb, Booking e Aluguel por Temporada",
      ],
      additionalInfo: "Ideal para quem precisa encantar logo na primeira foto e aumentar reservas.",
      image: "/lovable-uploads/2944ddc1-4b3e-4aa1-8a52-215f0619bc2c.png",
    },
  ];

  return (
    <section aria-labelledby="titulo-servicos" className="py-24 bg-white">
        <div className="container max-w-7xl mx-auto px-4">
          <div className="text-center mb-20">
            <h2 id="titulo-servicos" className="text-4xl md:text-5xl font-bold text-[#323031] mb-6">
              Pacotes de fotografia imobiliária para <span className="text-[#FF5605]">corretores e imobiliárias</span>
            </h2>
            <p className="text-xl text-[#5B5A59] max-w-3xl mx-auto">
              Fotos de imóveis em Itajaí, Camboriú e Porto Belo com entrega em 48h. Escolha o pacote ideal para destacar seu imóvel no mercado.
            </p>
          </div>

          <div className="grid lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div
                key={index}
                className={`relative bg-white rounded-3xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300 ${
                  service.popular ? "ring-4 ring-[#FF5605] scale-105" : ""
                }`}
              >
                {service.popular && (
                  <div className="absolute top-0 left-1/2 transform -translate-x-1/2 bg-[#FF5605] text-white px-6 py-2 rounded-b-xl font-semibold flex items-center">
                    <Star className="h-4 w-4 mr-1" />
                    Mais usado no mercado
                  </div>
                )}

                <div className="h-48 overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.alt}
                    loading="lazy"
                    width="400"
                    height="192"
                    className="w-full h-full object-cover"
                  />
                </div>

                <div className="p-8">
                  <h3 className="text-2xl font-bold text-[#323031] mb-2">
                    {service.title}
                  </h3>

                  <p className="text-[#5B5A59] mb-4">
                    {service.description}
                  </p>

                  <ul className="space-y-3 mb-6">
                    {service.features.map((feature, idx) => (
                      <li key={idx} className="flex items-center">
                        <Check className="h-5 w-5 text-[#FF5605] mr-3 flex-shrink-0" />
                        <span className="text-[#323031]">{feature}</span>
                      </li>
                    ))}
                  </ul>

                  <p className="text-[#5B5A59] text-sm mb-8 italic">
                    {service.additionalInfo}
                  </p>

                  <Button
                    asChild
                    className={`w-full rounded-full py-6 text-lg font-semibold group ${
                      service.popular
                        ? "bg-[#FF5605] hover:bg-[#E14D04] text-white"
                        : "bg-transparent border-2 border-[#FF5605] text-[#FF5605] hover:bg-[#FF5605] hover:text-white"
                    }`}
                  >
                    <Link to="/servicos" className="flex items-center justify-center">
                      Solicitar orçamento
                      <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
                    </Link>
                  </Button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
  );
};

export default TocTocServices;

